'use strict';

import imagesLoaded from 'imagesloaded';
import ajax from './ajax';
import images from './pages/product/image';
import quickview from './quickview';
import variant from './pages/product/variant';
import util from './util';
import minicart from './minicart';
import cart from './pages/cart';
import page from './page';
import search from './pages/search';
import recommendations from './pages/product/recommendations';
import analytics from './analytics';

function initQuickViewButtons() {

	if (!quickViewEnabled || $(window).width()<768) {
		$('.tiles-container .product-image .quickview').off().on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
        
            //if non variant addd to bag
            if ($(this).attr('data-product-isvariant') == "false") {
                minicart.addProduct({ pid: $(this).attr('data-product-id'), Quantity: '1' }, $(this).find('.a2c-error-quickview'));
                if($(this).closest('.plp-cross-sell').length) {
                    analytics.addToBagPLPCrosssell($(this).closest('.recommendation-item'), e);
                }
                if($('#cart-items-form').length > 0 || $(this).parents().hasClass('cart-empty-container')){ //recommendations section
                    $('.minicart-overlay').hide();
                    page.refresh();
                }             

            } else {
                window.location.href = $(this).attr('href');
            }//if variant redirect to pdp    
        });
	} else {
        $('.tiles-container .product-image .quickview').off().on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();   
    
                    var url = $(this).attr('href');
                    var $productTile = $(this).parents('.product-tile');
                    var $miniqvcontainer =  $productTile.find('.quickview-mini-modal');
                    var tileHeight = $productTile.outerHeight(true);
                    var tileX = parseInt($productTile.offset().top);
                    var executedFlag = false;
                    
                    if(SitePreferences.MINIQUICKVIEW === 'true' && $(this).attr('data-product-isvariant') == "false"){	
                        executedFlag = true;
                        const $gtmValue = $productTile.find('.gtm-product-tile');
                        const tileVariantData = $gtmValue.data('value');
                        if($(this).parents('.crosssell-recommendation-modal .recommendation-item').length >= 1){//gymshark
                            analytics.addToCartGymShark($(this).parents('.recommendation-item'));
                        } else if($(this).closest('.plp-cross-sell').length) {
                            analytics.addToBagPLPCrosssell($(this).closest('.recommendation-item'), e);
                        } else {
                             analytics.addToCartDataLayerPush(tileVariantData);//add to cart for non variant
                        }                       

                        minicart.addProduct({ pid: $(this).attr('data-product-id'), Quantity: '1'},  $(this).find('.a2c-error-quickview'));
                        //cart page recommendation page refresh
                        if($('#cart-items-form').length > 0 || $(this).parents().hasClass('cart-empty-container')){ //recommendations section
                            $('.minicart-overlay').hide();
                            page.refresh();
                        }                                                
                    }
    
                    if(SitePreferences.MINIQUICKVIEW === 'true' && !executedFlag){	
                        $('.quickview-mini-modal  .icon-close').trigger('click');
                        var $quickview_panel = $(this).parents('.product-tile').find('.quickview-mini-modal');
                        $quickview_panel.removeClass("hide");
                           
                        quickview.showmini({
                            url: $(this).attr('href'),
                            source: 'miniquickview',
                            qvContainer : $miniqvcontainer,
                            callback: function() {
                                images();
                                variant();
                                plpSwatchTrigger();
                                $quickview_panel.addClass("isOpened");
        
                                $('#BVRRSummaryContainer').on('click', '.bv-rating-stars-container', function() {
                                    window.location.href = url + '#reviews'; // redirect when rating star is clicked
                                });
        
                                $(document).on('click', '.bv-popup-in .bv-read-review', function() {
                                    window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
                                });
                                $('select.variation-filter-selects', $miniqvcontainer).trigger( "change" );
                                if($quickview_panel.closest(".recommendations-wrapper").length > 0 && $quickview_panel.find("#product-content .color li").length > 24){
                                    $($quickview_panel.find("#product-content .color li.view-all").removeClass("hide").addClass("showMoreLink"));
                                } else {
                                    $($quickview_panel.find("#product-content .color li.view-all").addClass("hide"));
                                }
                            }
                        });
                    }
                    else if(!executedFlag){
                        quickview.show({
                            url: $(this).attr('href'),
                            source: 'quickview',				  
                            callback: function(){
                            images();
                            variant();
                            renderThumbnails();
                            plpSwatchTrigger();
    
                            $('#BVRRSummaryContainer').on('click', '.bv-rating-stars-container', function() {
                                window.location.href = url + '#reviews'; // redirect when rating star is clicked
                            });
    
                            $(document).on('click', '.bv-popup-in .bv-read-review', function() {
                                window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
                            });
                            $('select#skinType').trigger( "change" );
                        }
                    });
                }
        });
    }

    if (!quickViewEnabled) {
		$('.tiles-container .product-image .quickview').off().on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
        
            //if non variant addd to bag
            if ($(this).attr('data-product-isvariant') == "false") {
                minicart.addProduct({ pid: $(this).attr('data-product-id'), Quantity: '1' }, $(this).find('.a2c-error-quickview'));
                if($('#cart-items-form').length > 0 || $(this).parents().hasClass('cart-empty-container')){ //recommendations section
                    $('.minicart-overlay').hide();
                    page.refresh();
                }          

            } else {
                window.location.href = $(this).attr('href');
            }//if variant redirect to pdp    
        });
	} 
}

$(document).on('click', '.quickview-mini-modal  .icon-close', function(e) {
    e.stopPropagation();
	   $('.product-tile').find('.quickview-mini-modal').removeClass('isOpened').addClass('hide');
	   $('.quickview-mini-modal').empty();
});

$(document).on('click', function (e) {
	var $target = $(e.target);
    if($target.closest(".quickview-mini-modal").length == 0) {
        $('.quickview-mini-modal.isOpened .icon-close').trigger('click');
    }
});

function gridViewToggle() {
    $('.toggle-grid').on('click', function () {
        $('.search-result-content').toggleClass('wide-tiles');
        $(this).toggleClass('wide');
    });
}

function renderThumbnails(){
	if($('#thumbnails').length > 0){
		$('#thumbnails').empty();	// clear the list
		images();					// populate the thumbnails
	}
};

function initCarouselSwatches() {
    $('.swatch-list').not(".slick-slider").slick({
    	dots: false,
        focusOnSelect: true,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 3,
        speed: 300
    });
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
    initQuickViewButtons();
    gridViewToggle();
    $('.swatch-list').on('mouseleave', function () {
        // Restore current thumb image
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img').eq(0),
            data = $thumb.data('current');

        if(!data) { return; }

        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });
    /*$(document).on('click', '.swatches .view-all', function() {
        $(this).closest('.swatches').addClass("expanded");
    });*/
    $('.swatch-list .swatch').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('selected')) { return; }

        var $tile = $(this).closest('.product-tile');
        $(this).closest('.swatch-list').find('.swatch.selected').removeClass('selected');
        $(this).addClass('selected');
        $tile.find('.thumb-link').attr('href', $(this).attr('href'));
        $tile.find('name-link').attr('href', $(this).attr('href'));

        var data = $(this).children('img').filter(':first').data('thumb');
        var $thumb = $tile.find('.product-image .thumb-link img').eq(0);
        var currentAttrs = {
            src: data.src,
            alt: data.alt,
            title: data.title
        };
        $thumb.attr(currentAttrs);
        $thumb.data('current', currentAttrs);
    }).on('mouseenter', function () {
        // get current thumb details
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img').eq(0),
            data = $(this).children('img').filter(':first').data('thumb'),
            current = $thumb.data('current');

        if(!data) { return; }

        // If this is the first time, then record the current img
        if (!current) {
            $thumb.data('current', {
                src: $thumb[0].src,
                alt: $thumb[0].alt,
                title: $thumb[0].title
            });
        }

        // Set the tile image to the values provided on the swatch data attributes
        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });
    
    $('.shipping-vat-info-toast').on('click', '.vat-info-link', function(e) {		
		e.preventDefault();
		e.stopImmediatePropagation();
		var $this = $(this);
		$.ajax({
			url: util.appendParamToURL($this.attr('href'), 'format', 'ajax'),
			method: 'GET'
		})
		.done(function (response) { 
			if (response) {
                modal.addCustomClass('checkout-reinsurance-inner-wrapper');
                modal.renderContent(response);
			}
		});
        analytics.reinsuranceElements($this.attr('id'));
	});
}

function addRegimenItemTobag(){
	$(".regimenzone").off().on('click', '.add-all', function(e) {
        e.preventDefault();
        
        var pidArr = [];
        var $regimenbg =  $(".regimenzone").find(".regimen-container");		
		$regimenbg.find('.gtm-product-tile').each(function () {			
			var tileVariantData = $(this).data('value');
			pidArr.push(tileVariantData.ID+":1");
		});
		var pidData = pidArr.toString();
        const errorElement = $('.regimenzone').find('#a2c-error-all');
		
        minicart.addAllProducts(pidData, "Cart", errorElement);
     
    });
}

// redirect when rating star is clicked
$(document).on('click', '.product-title .bv_main_container', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if(!$('.accordion-item.bazaarvoice-view').hasClass('is-active')){
            $('.bazaarvoice-view').find('.accordion-title').trigger('click');
        }

        $('html, body').stop(true, true).animate({
            scrollTop: parseFloat($("#reviews").offset().top) - 150 + 'px'
        }, 1000);
});

// redirect when read reviews button is clicked
$(document).on('click', '#bv_components_histogram', function (e) {
    if($('.bv_modal_component_container').length > 0) {
        e.preventDefault();
        e.stopPropagation();

        if(!$('.accordion-item.bazaarvoice-view').hasClass('is-active')){
            $('.bazaarvoice-view').find('.accordion-title').trigger('click');
        }

        $('html, body').stop(true, true).animate({
            scrollTop: parseFloat($("#reviews").offset().top) - 150 + 'px'
        }, 1000);
    }
});	

// Product tab move to top position if data inside content wrapper more
$(document).on('click', '.product-info .accordion-title', function (e) {
    e.preventDefault();
    e.stopPropagation();

    //Toggle between the accordions without any scroll or library
    $(this).next('.accordion-content').toggle();
    $(this).closest('.accordion-item').toggleClass('is-active');
    $(this).toggleClass('active');
    //Commented below code to disable the close of other accordion tabs and scroll
   /* var winScrollTop = $(window).scrollTop(),
        pdpTabContainer = $('.pdp-info-tabs').offset().top;

    if (!$('.product-info .accordion-item').hasClass('is-active') && $('.productset-container').length && $(window).width() > 991) {
        isFooterInViewport();
    } else {
        if (winScrollTop > pdpTabContainer) {
            $('html, body').stop(true, true).animate({
                scrollTop: parseFloat(pdpTabContainer) - 150 + 'px'
            }, 1000);
        }
    }*/
});

function isFooterInViewport() { // Check footer is in viewport
    var target = document.querySelector('.footer-container');

    var observer = new IntersectionObserver(handleIntersection);
    observer.observe(target);

    function handleIntersection(entries) {
        entries.map((entry) => {
            if (entry.isIntersecting) {
                $('html, body').stop(true, true).animate({
                    scrollTop: parseFloat($('.pdp-info-tabs').offset().top - $('.pdp-info-tabs').height()) + 'px'
                }, 1000);

                observer.unobserve(target);
            }
        });
    }
}

//Regimen product redesign
function regimeSscrollTracker() {
	if($('#pdpMain').length > 0 && $('.regimenzone-redesign-mobile').length > 0) {
		if($(window).width() < 991){
			// OverlayScrollbars initialization with an element
			const osInstance = OverlayScrollbars(document.querySelector('.regimenzone-redesign-mobile .regimen-carousel'), {});
			
			$('#pdpMain').addClass('re-regimen-active');
			//util.equalHeight($('.regimenzone-redesign-mobile .product-tile-wrapper'));
			var elementSelector = $('.regimenzone-redesign-mobile .product-tile-wrapper');
			elementSelector.each(function (index, ele) {
			$(ele).find('.attribute .basic-price').length > 0 && $(ele).find('.product-variants-wrapper').addClass('shift-up');
		});
		} else {
			const osInstance = OverlayScrollbars(document.querySelector('.regimenzone-redesign-mobile .regimen-container'), {}).destroy();
			$('.regimenzone-redesign-mobile .product-tile-wrapper').removeAttr('style');
		}
	}
  }

  /**
 * plp trigger for color swatch
 */
function plpSwatchTrigger() {
    $('.plp-tile-swatch-wrapper a.swatchanchor').off().on('click', function(e) {
        e.preventDefault();
        $(this).parents('.product-variations').find('.product-loader-swatch').addClass('is-active');
        var targetContainer = $(this).parents('.product-tile-main-wrapper');
        updatePLPContent(this.href,targetContainer, $(this));
    });

}

function updatePLPContent(href, targetContainer,$ele) {
    var result = JSON.parse(JSON.stringify(util.parseQueryString(href)));
	result.Quantity = '1';
	result.format = 'ajax';
	result.template = 'product/redesign/producttile';
    result.isPLPAjax='true';
	   
    ajax.load({
        url: util.appendParamsToUrl(Urls.transactionalHitTile, result),
        target: targetContainer,
        callback: function () {
            variant();
            renderThumbnails();
            plpSwatchTrigger();
            initQuickViewButtons();
            $('.product-loader-swatch').removeClass('is-active');
            search.initColorShadesSliderPlp();
            if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
                search.initPLPSlider();
            }
            $('#BVRRSummaryContainer').on('click', '.bv-rating-stars-container', function() {
                window.location.href = url + '#reviews'; // redirect when rating star is clicked
            });

            $(document).on('click', '.bv-popup-in .bv-read-review', function() {
                window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
            });
        }
    });
}

$(".cross-section").on("click", function() {
    const $redirectUrl = $(this).attr("data-href");
    window.location.href = $redirectUrl;
});

export default {
    init: function () {
        var $tiles = $('.tiles-container .product-tile');
        var $discountPercentage = $('.product-tile .discount-percentage');
        var $productPackshotWrapper = $('.product-tile .product-packshot-wrapper');
        if ($tiles.length === 0) { return; }
        if ($productPackshotWrapper.parent('.product-tile').find($discountPercentage).css('display') == 'none') { $productPackshotWrapper.addClass('no-space') }
        initCarouselSwatches();
        initializeEvents();
        regimeSscrollTracker();
        $(window).on('resize orientationchange', function () {
            initializeEvents();
            regimeSscrollTracker();
        });

        addRegimenItemTobag();
        if ($('.pt_product-search-result').length > 0) {
            $('.product-tiles-holder .product-item').each(function () {
                var productPricing = $(this).find('.product-pricing');
                $('.ominibus-price-wrapper').length > 0 && productPricing.addClass('ominibus-padding');
            });
        }
        cart.multiSelectSample();
        cart.addSelectedSamplesCart();
        plpSwatchTrigger();
        recommendations.init();
    },
    initCarouselSwatches: initCarouselSwatches,
    addRegimenItemTobag: addRegimenItemTobag
};




